<div *ngIf="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success',
                                  'alert-danger': message.type === 'error' }">
  <span [innerHTML]="renderedText"></span>
  <button mat-icon-button
          class="close-icon"
          [ngStyle]="iconStyle"
          (click)="close()">
    <mat-icon aria-label="Close icon">close</mat-icon>
  </button>
</div>
